/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { createColumnHelper } from "@tanstack/react-table";
import dayjs from "dayjs";
import { Text, Tag } from "@nordcloud/gnui";
import { AuditLog } from "~/generated/graphql";
import { MediumColumn, SmallIconColumn } from "~/components/Tables/styles";
import { dateFormat } from "~/constants";
import { AuditLogDetailsButton } from "./AuditLogDetailsButton";

const columnHelper = createColumnHelper<AuditLog>();

export function columns() {
  return [
    columnHelper.accessor(() => null, {
      id: "date",
      header: "Date",
      cell: ({ row }) => {
        return (
          <Text>
            {dayjs(row.original.datetime).format(
              dateFormat.dayMonthYearHourMinute
            )}
          </Text>
        );
      },
      meta: MediumColumn,
    }),
    columnHelper.accessor(() => null, {
      id: "identityType",
      header: () => "Identity Type",
      cell: ({ row }) => {
        return <Tag text={row.original.identityType} />;
      },
      meta: MediumColumn,
    }),
    columnHelper.accessor(() => null, {
      id: "identity",
      header: "Identity",
      cell: ({ row }) => {
        return <Text>{row.original.identity}</Text>;
      },
      meta: MediumColumn,
    }),
    columnHelper.accessor(() => null, {
      id: "operation",
      header: "Operation",
      cell: ({ row }) => {
        return <Text>{getCapitalCase(row.original.operation)}</Text>;
      },
      meta: MediumColumn,
    }),
    columnHelper.accessor(() => null, {
      id: "target",
      header: "Target",
      cell: ({ row }) => {
        return <Text>{getCapitalCase(row.original.target)}</Text>;
      },
      meta: MediumColumn,
    }),
    columnHelper.accessor(() => null, {
      id: "options",
      header: () => null,
      cell: ({ row }) => {
        return <AuditLogDetailsButton auditLog={row.original} />;
      },
      meta: SmallIconColumn,
    }),
  ] as never;
}

function getCapitalCase(str: string) {
  return str
    .replace(/_/g, " ")
    .replace(/([A-Z])/g, " $1")
    .replace(/\b\w/g, (match) => match.toUpperCase())
    .trim();
}
